import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { OfflineBanner } from './components/OfflineBanner';
import { initGa } from './lib/ga';
import { initMonitoring } from './lib/monitoring';
import { refreshReminder } from './lib/reminder';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <OfflineBanner />
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

// Analytics and error reporting load after first paint so they never delay LCP.
const idle = window.requestIdleCallback ?? ((cb: () => void) => window.setTimeout(cb, 1500));
idle(() => {
  initGa();
  void initMonitoring();
  // Installable PWA (production builds only; dev keeps hot reload simple).
  if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/sw.js')
      .then(() => refreshReminder())
      .catch(() => undefined);
  }
});
